import { useState } from 'react';
import { api } from '../lib/api';
import { useStore } from '../store';
import { UsersIcon } from './icons';

export function GuildRail() {
  const guildOrder = useStore((s) => s.guildOrder);
  const guilds = useStore((s) => s.guilds);
  const activeGuildId = useStore((s) => s.activeGuildId);
  const selectGuild = useStore((s) => s.selectGuild);
  const toast = useStore((s) => s.toast);
  const amizades = useStore((s) => s.amizades);
  const mostrandoAmigos = useStore((s) => s.painelAmigos);
  const setPainelAmigos = useStore((s) => s.setPainelAmigos);
  const [creating, setCreating] = useState(false);

  async function createGuild() {
    const name = window.prompt('Nome da nova guild:');
    if (!name?.trim()) return;
    setCreating(true);
    try {
      const { guild } = await api.createGuild(name.trim());
      toast(`Guild "${guild.name}" criada.`);
      // O snapshot atualizado chega pelo gateway logo em seguida.
    } catch (error) {
      toast(error instanceof Error ? error.message : 'Falha ao criar guild.', 'error');
    } finally {
      setCreating(false);
    }
  }

  const pedidosPendentes = amizades.filter((a) => a.status === 'pendente' && !a.outgoing).length;

  return (
    <div className="guild-rail">
      {/* Amigos e conversas ficam acima das guilds: nao pertencem a nenhuma. */}
      <button
        className={`guild-pill casa ${mostrandoAmigos ? 'active' : ''}`}
        title="Amigos e conversas"
        onClick={() => setPainelAmigos(!mostrandoAmigos)}
      >
        <UsersIcon style={{ width: 22, height: 22 }} />
        {pedidosPendentes > 0 && <span className="pill-badge">{pedidosPendentes}</span>}
      </button>
      <div className="guild-rail-divisor" />

      {guildOrder.map((guildId) => {
        const bundle = guilds[guildId];
        if (!bundle) return null;
        return (
          <button
            key={guildId}
            className={`guild-pill ${guildId === activeGuildId ? 'active' : ''}`}
            style={{ background: bundle.guild.iconColor }}
            title={bundle.guild.name}
            onClick={() => selectGuild(guildId)}
          >
            {bundle.guild.name.slice(0, 2).toUpperCase()}
          </button>
        );
      })}
      <button
        className="guild-pill add"
        title="Criar guild"
        onClick={() => void createGuild()}
        disabled={creating}
      >
        +
      </button>
    </div>
  );
}
